/*/
 * Anchor
 *
 * Target: href | data-target
 * Align:  start | center | end | nearest
 *
/*/
	const siteAnchor = document.querySelectorAll('[site-anchor]')

	if (siteAnchor) {
		siteAnchor.forEach(e => {
			e.addEventListener('click', _ => {
				_.preventDefault()

				const dataTarget = e.dataset.target
				const hrefTarget = e.getAttribute('href')
				const dataAlign = e.dataset.align ? e.dataset.align : 'start'

				if (dataTarget) {
					document.querySelector(dataTarget).scrollIntoView({
						behavior: 'smooth',
						block: dataAlign,
						inline: 'nearest'
					})
				} else if (hrefTarget) {
					document.querySelector(hrefTarget).scrollIntoView({
						behavior: 'smooth',
						block: dataAlign,
						inline: 'nearest'
					})
				}
			})
		})
	}
